module.exports = __webpack_public_path__ + "img/Woman-7.40e12393.svg";